import React, { useContext } from 'react';
import { I18nextProvider } from 'react-i18next';
import './App.css';
import ContextAuth, { AuthContext } from './contextStore/AuthContext';
import AppProviders from './contextStore/AppProviders';
import MainRoutes from './Routes/MainRoutes';
import BarLoading from './Components/Loading/BarLoading';
import i18n from './i18n';

function AppContent() {
  const { authLoading } = useContext(AuthContext);
  if (authLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <BarLoading />
      </div>
    );
  }
  return (
    <AppProviders>
      <MainRoutes />
    </AppProviders>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ContextAuth>
        <AppContent />
      </ContextAuth>
    </I18nextProvider>
  );
}

export default App;
